import {ChangeDetectionStrategy, Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ProgressSpinner} from 'primeng/progressspinner';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'homey-pay-redirect-page',
  standalone: true,
  imports: [ProgressSpinner],
  templateUrl: './pay-redirect-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayRedirectPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly http = inject(HttpClient);

  protected readonly error = signal<string | null>(null);

  async ngOnInit(): Promise<void> {
    const id = this.route.snapshot.queryParamMap.get('id');
    if (!id) {
      this.error.set('Invalid link. Please check your email or SMS for the correct link.');
      return;
    }

    try {
      const response = await firstValueFrom(
        this.http.get<{ url: string }>(`${environment.apiUrl}/api/public/payment/pay`, {params: {id}})
      );
      window.location.href = response.url;
    } catch {
      this.error.set('Something went wrong. Please try again or contact support.');
    }
  }
}
